module.exports = "/_next/static/images/6eba4af1d0c63b71bf1db3bc45a17951-mulher-perfil-segurando-cartao-md@1x.jpg.webp";